import React from 'react';

const LineCounter: React.FC<{
  className?: string;
  color?: string;
  count: number;
  total: number;
}> = ({ className = '', color = 'green-400', count, total }) => (
  <span
    aria-hidden="true"
    className={[
      'grid w-full border-t-2 border-gray-200 relative',
      className,
    ].join(' ')}
  >
    <span
      className={[
        'grid absolute left-0 bottom-0 border-t-2',
        `border-${color}`,
      ].join(' ')}
      style={{ width: `${(count * 100) / total}%` }}
    ></span>
  </span>
);

export default LineCounter;
